<template>
  <div class="Page">
    <v-container>
      <v-row>
        <v-col class="text-center">
          <h1>{{page.title}}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div v-html="getImageTags(page.content)"></div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        page: {

        }
      }
    },
    beforeMount: function(){
      fetch(
          "https://www.artlesscms.actstudio.xyz/api/collections/get/Pages?token=a15be93e9cdb43ca2b3778c2077c26",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                url: this.$route.params.url,
              }
            }),
          }
      )
          .then((res) => res.json())
          .then((res) => (this.page = res.entries[0]))
    },
    methods: {
      getImageTags: function (text) {

        var res = text.replaceAll('<img src="/', '<img src="https://www.artlesscms.actstudio.xyz/');

        return res;
      }
    }
  }
</script>